import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from '@chakra-ui/react';
import { Input as FInput, Textarea } from '@forest/forms';
import { connect, mapProps, mapReadPretty } from '@formily/react';
import { PreviewText } from '../PreviewText';
export const Input = connect(FInput, mapProps((props, field) => {
    return Object.assign(Object.assign({}, props), { suffix: (field === null || field === void 0 ? void 0 : field['loading']) || (field === null || field === void 0 ? void 0 : field['validating']) ? (_jsx(Spinner, { size: props.size, color: "gray.200" })) : (props.suffix) });
}), mapReadPretty(PreviewText.Input));
Input.TextArea = connect(Textarea, mapProps((props, field) => {
    return Object.assign({}, props);
}));
export default Input;
